import React from 'react';
import { motion } from 'framer-motion';

export const ScaleField = ({ 
  id, 
  label, 
  value, 
  onChange, 
  scaleMin = 1,
  scaleMax = 5,
  scaleLabels = {},
  required = false,
  error = null,
  helpText = null
}) => {
  const scaleValues = Array.from(
    { length: scaleMax - scaleMin + 1 }, 
    (_, i) => scaleMin + i
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mb-6"
    >
      <label className="block text-sm font-semibold text-gray-200 mb-3">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      
      {helpText && (
        <p className="text-sm text-gray-400 mb-3">{helpText}</p>
      )}
      
      {/* Scale labels */}
      <div className="mb-4 space-y-2">
        {Object.entries(scaleLabels).map(([key, labelText]) => (
          <div key={key} className="flex items-start text-sm">
            <span className="font-semibold text-teal-400 mr-2">{key}:</span>
            <span className="text-gray-300">{labelText}</span>
          </div>
        ))}
      </div>

      {/* Scale buttons */}
      <div className="flex gap-2 justify-between">
        {scaleValues.map((scaleValue) => {
          const isSelected = String(value) === String(scaleValue);
          return (
            <motion.button
              key={scaleValue}
              type="button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onChange(String(scaleValue))}
              className={`flex-1 py-4 rounded-lg border-2 font-semibold text-lg transition-all ${
                isSelected
                  ? 'border-teal-500 bg-teal-500 text-white shadow-lg'
                  : 'border-gray-700 bg-gray-800 text-gray-300 hover:border-gray-600'
              }`}
            >
              {scaleValue}
            </motion.button>
          );
        })}
      </div>
      
      <div className="flex justify-between mt-2 text-xs text-gray-400">
        <span>{scaleLabels[scaleMin] ? `${scaleMin} - ${scaleLabels[scaleMin].split(' - ')[0]}` : scaleMin}</span>
        <span>{scaleLabels[scaleMax] ? `${scaleMax} - ${scaleLabels[scaleMax].split(' - ')[0]}` : scaleMax}</span>
      </div>
      
      {error && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-red-400 text-sm mt-2"
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

